<template>
  <form @submit.prevent="registerWithCaptcha" v-if="doesAuthTypeEnabled('recaptcha')">
      <span>Wpisz swoje imię i zweryfikuj, że nie jesteś botem</span>
      <input type="text" placeholder="Twoje imię" v-model="shortForm.user_name" required style="margin: 15px 0"/>
      <div class="recaptcha">
        <vue-recaptcha ref="recaptcha" :sitekey="sitekey" @verify="saveRecaptchaResponse" size="normal"/>
      </div>
      <button :disabled="!checkForData">Wchodzę</button>
  </form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { VueRecaptcha } from 'vue-recaptcha'
import { CAPTCHA_SITE_KEY } from '../../../env'

export default {
  name: 'Authorization',
  data () {
    return {
      form: {
        phone_number: '',
        pin_code: ''
      },
      shortForm: {
        user_name: '',
        google_recaptcha_response: ''
      },
      sitekey: CAPTCHA_SITE_KEY,
      toggle: false,
      resetContainer: false
    }
  },
  components: {
    VueRecaptcha
  },
  computed: {
    ...mapGetters({
      authMethods: 'auth/getAuthState'
    }),
    checkForData () {
      return this.shortForm.google_recaptcha_response && this.shortForm.user_name
    }
  },
  mounted () {
    this.setAuthMethods()
  },
  methods: {
    ...mapActions({
      setAuthMethods: 'auth/setAuthMethods'
    }),
    onRecaptcha () {
      this.$refs.recaptcha.execute()
    },
    login () {
      this.$emit('login', this.form)
    },
    registerWithPhone () {
      this.$emit('registerWithPhone', this.form.phone_number)
    },
    registerWithCaptcha () {
      this.$emit('registerWithCaptcha', this.shortForm)
    },
    saveRecaptchaResponse (response) {
      this.shortForm.google_recaptcha_response = response
    },
    doesAuthTypeEnabled (type) {
      return this.authMethods.enabled_auth_types?.includes(type)
    },
    reset () {
      this.$emit('reset', this.form.phone_number)
    },
    toggleContainerClass () {
      this.toggle = !this.toggle
    },
    toggleResetContainer () {
      this.resetContainer = !this.resetContainer
    },
    oauth (provider) {
      this.$emit('oauth', provider)
    }
  }
}
</script>

<style scoped lang="scss">
.chatBody {
  padding: 10px 15px 0 15px;
  height: 350px;
  overflow: auto;
}

* {
  box-sizing: border-box;
}

h1 {
  font-weight: bold;
  margin: 0;
}

h2 {
  text-align: center;
}

p {
  font-size: 14px;
  font-weight: 100;
  line-height: 20px;
  letter-spacing: 0.5px;
  margin: 20px 0 30px;
}

span {
  font-size: 12px;
  line-height: 18px;
}

form {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  margin: auto;
  input[type=text] {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
    display: flex;
    align-items: center;
    color: #555;
    border: 1px solid #eee;
    border-radius: 25px;
    padding: 10px 15px;
    flex: 1;
    margin: 0;
    font-family: 'Roboto', sans-serif;
    max-width: 85%;
    width: 100%;
    &:focus, &:active {
      border: 1px solid #c9c9c9;
      outline: 0;
    }

    &:-webkit-autofill:focus, &:-webkit-autofill {
      -webkit-box-shadow: 0 0 0 50px white inset;
      -webkit-text-fill-color: #333;
    }
  }

  button {
    width: auto;
    padding: 7px 20px;
    text-align: center;
    color: #fff;
    font-size: 12px;
    line-height: 20px;
    background-color: #20653F;
    border-radius: 15px;
    border: none;
    font-weight: 500;
    cursor: pointer;
    margin: 20px 0 0 0;
    font-family: 'Roboto', sans-serif;
    -webkit-transition: all 1s ease-out;
    -moz-transition: all 1s ease-out;
    -o-transition: all 1s ease-out;
    transition: all 1s ease-out;
    &:not(:disabled):hover {
      background-color: #20653F;
    }

    &:disabled {
      opacity: .7;
      cursor: default;
    }
  }
}

.recaptcha {
  transform: scale(0.85);
  text-align: center;
}
</style>
